import { ACTION_TYPES } from '../../utils/Constants';
import { myLog } from '../../utils/Utility';

const MyProviderReducer = (
    state = {
        totalPages: 0,
        categoryListDetails: [],
        subCategoryListDetails: [],
        physicianSpecicalityListDetails: [],
        physicianAvailabilityListDetails: [],
        getCollapse: '',
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.PATIENT.GET_SUB_CATEGORY_LIST:
            myLog('subCategoryListDetails', action.payload);
            state = {
                ...state,
                subCategoryListDetails: action.payload,
            };
            break;
        case ACTION_TYPES.PATIENT.GET_PHYSICIAN_AVAILABILITY:
            myLog('physician physicianAvailability', action.payload);
            state = {
                ...state,
                physicianAvailabilityListDetails: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};
export default MyProviderReducer;
